import React, { useState } from "react";
import { useDispatch, useSelector, useEf } from "react-redux";
import UtiDetailsBox from "./box/UtiDetailsBox";
import "./OrderDetails.css";
import Carousel from "react-material-ui-carousel";

const OrderDetails = (props) => {
  
  const isMobile = window.innerWidth <= 760
  
  const [titles, setTitles] = useState({
    'orderData': 'נתוני הזמנה',
    'truckData': 'משאית',
    'mirkavData': 'מרכב',
    'paymentData' : 'מצב חשבון'
  })
  const getDetails=()=>{
    const length = Object.keys(items).length;
    const number = 100 / length;
    return(
      props.data && Object.keys(items).map(key => (
        <UtiDetailsBox data={props?.data[key]} title={titles[key]} width={number + "%"} items={items[key]}/>
      ))
    )
  }
  
  const createItems = (type, orderType) => {
    let items = {
      'orderData': ["id", "uti_id", "date", "price", "dealType", "position", "oldLic" ],
      'truckData': ['modelName', 'licNum', 'chassisCode', 'deliveryExpected'],
    };

    // adding mirkav only if not shilda only
    if (orderType && orderType?.includes('שילדה בלבד')) {
      items = {...items, 'mirkavData': ['boxSupp', 'boxType', 'boxLength']};
    }
  
    // adding paymentData only for NewCar
    if (type === 'NewCar') {
      items = {...items, 'paymentData' : ['totalWithoutVat','vat', 'tradeIn', 'paid', 'feeToPay', 'leftToPay']};
    }

    return items;
  
  }

  const [items, setItems] = useState(createItems(props.data.type, props.data.orderType));

    return (
      <div className="row">
      <div className="width-100">
        <h5 className='title-docs'>פרטי הזמנה</h5>
        <div className='row-docs order-det-row'>
          {isMobile?<Carousel navButtonsAlwaysInvisible={true} autoPlay={false}>{getDetails()}</Carousel>:<>{getDetails()}</>}
        </div>
        </div>
      </div>  
  );
};

export default OrderDetails;
